export interface IShipping {
    id: string;
    store: number;
    postOffice: number;
    overnightStore: number;
    overnightPostOffice: number;
}

export const DefaultShippingCost = (): IShipping => {
    return {
        id: '',
        overnightPostOffice: 0,
        overnightStore: 0,
        postOffice: 0,
        store: 0
    };
};
